import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../core/routes/routes";
import { DateUtil } from "../../common/utils/date.util";
import { useInfractionsQuery } from "./hooks/useInfractionsQuery.js";
import { useInfractionCommand } from "./hooks/useInfractionCommad.js";
import IconButton from "../../common/components/IconButton";
import Table from "../../common/components/Table";
import Textfield from "../../common/components/Textfiled";
import Pagination from "../../common/components/Pagination";
import FormInfraction from "./components/FormInfraction.jsx";
import { BsClipboardPlus, BsFileSpreadsheet, BsPencilSquare, BsTrash } from "react-icons/bs";

function ListInfractions() {
  const navigate = useNavigate();

  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    search: "",
  });
  const { infractions, currentPage, loading, onChangePage, totalPages, refresh } =
    useInfractionsQuery(filters);
  const {
    exportToExcel,
    deleteInfraction,
    updateInfraction,
    infraction,
    handleChange,
    setDefaultValues,
    errors,
  } = useInfractionCommand(refresh);

  const [showEditModal, setShowEditModal] = useState(false);

  const handleEdit = (item) => {
    setDefaultValues(item);
    setShowEditModal(true);
  };

  const handleUpdate = async () => {
    await updateInfraction();
    setShowEditModal(false);
  };

  const columns = [
    { header: "Código", accessor: "code" },
    {
      header: "Fecha",
      accessor: "date",
      render: (value) => DateUtil.format(value, "DD/MM/YYYY"),
    },
    { header: "Conductor", accessor: "driverName" },
    { header: "Identificación", accessor: "driverIdentification" },
    { header: "Placa", accessor: "plate" },
    { header: "Tipo", accessor: "type" },
    { header: "Departamento", accessor: "department" },
    { header: "Ciudad", accessor: "city" },
    { header: "Autoridad", accessor: "authority" },
    { header: "Estado", accessor: "status" },
    {
      header: "Acciones",
      accessor: "actions",
      render: (_, item) => (
        <div className="d-flex align-items-center gap-2">
          <IconButton tooltipText="Editar" onClick={() => handleEdit(item)}>
            <BsPencilSquare size={20} />
          </IconButton>
          <IconButton
            tooltipText="Eliminar"
            onClick={() => deleteInfraction(item.id)}
          >
            <BsTrash size={20} color="#dc3545" />
          </IconButton>
        </div>
      ),
    },
  ];

  return (
    <main className="container-fluid p-4">
      <header className="d-flex justify-content-between align-items-center mb-4 px-3 py-2 border-bottom">
        <h1 className="h2 m-0 fw-bold">Lista de infracciones</h1>
        <div className="d-flex gap-2">
          <IconButton
            tooltipText="Registrar infracción"
            onClick={() => navigate(ROUTES.REGISTER_INFRACTIONS)}
          >
            <BsClipboardPlus size={24} />
          </IconButton>
          <IconButton
            tooltipText="Exportar a Excel"
            onClick={() => exportToExcel(filters)}
          >
            <BsFileSpreadsheet size={24} />
          </IconButton>
        </div>
      </header>

      <section className="shadow w-100 d-flex flex-column">
        <div className="d-flex gap-3 justify-content-center flex-wrap flex-md-nowrap justtify-content-md-end mb-3">
          <div className="w-100">
            <Textfield
              label="Buscar"
              name="search"
              onChange={({ value }) =>
                setFilters({ ...filters, search: value })
              }
              placeholder="Buscar..."
              value={filters.search}
            />
          </div>

          <div className="d-flex gap-1">
            <Textfield
              label="Fecha inicio"
              type="date"
              name="startDate"
              value={filters.startDate}
              onChange={({ value }) =>
                setFilters((prev) => ({ ...prev, startDate: value }))
              }
            />
            <Textfield
              label="Fecha fin"
              type="date"
              name="endDate"
              value={filters.endDate}
              onChange={({ value }) =>
                setFilters((prev) => ({ ...prev, endDate: value }))
              }
            />
          </div>
        </div>

        <Table
          columns={columns}
          data={infractions}
          showIndex={true}
          loading={loading}
        />

        <Pagination
          onChangePage={onChangePage}
          page={currentPage}
          totalPages={totalPages}
        />
      </section>

      {showEditModal && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1050 }}
          onClick={() => setShowEditModal(false)}
        >
          <div
            className="bg-white rounded shadow p-4"
            style={{ maxWidth: 700, width: "100%", maxHeight: "90vh", overflowY: "auto" }}
            onClick={(e) => e.stopPropagation()}
          >
            <h3 className="mb-3">Editar infracción</h3>
            <FormInfraction
              infraction={infraction}
              onChange={handleChange}
              errors={errors}
              onSubmit={handleUpdate}
            />
            <div className="d-flex justify-content-end mt-2">
              <button
                className="btn btn-secondary"
                onClick={() => setShowEditModal(false)}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}
    </main>
  );
}

export default ListInfractions;
